module.exports = __webpack_public_path__ + "img/full.ca5e0408.png";